if (typeof customElements.get('otm-countdown-banner') === 'undefined') {
  customElements.define(
    'otm-countdown-banner',
    class OtmCountdownBanner extends HTMLElement {
      constructor() {
        super();
        this.updateCountdown = this.updateCountdown.bind(this);
      }

      connectedCallback() {
        this.daysEl = this.querySelector('[data-unit="days"]');
        this.hoursEl = this.querySelector('[data-unit="hours"]');
        this.minutesEl = this.querySelector('[data-unit="minutes"]');
        this.secondsEl = this.querySelector('[data-unit="seconds"]');
        this.endDate = this.parseZonedEndDate(
          this.getAttribute('end-date'),
          this.getAttribute('end-time'),
          this.getAttribute('data-timezone') || 'Australia/Sydney'
        );

        if (isNaN(this.endDate)) {
          this.hideBanner();
          return;
        }

        this.updateCountdown();
        this.interval = setInterval(this.updateCountdown, 1000);
      }

      disconnectedCallback() {
        clearInterval(this.interval);
      }

      updateCountdown() {
        const distance = this.endDate - Date.now();

        if (distance < 0) {
          this.setUnitValues(0, 0, 0, 0);
          clearInterval(this.interval);
          this.hideBanner();
          return;
        }

        const days = Math.floor(distance / 86400000);
        const hours = Math.floor((distance % 86400000) / 3600000);
        const minutes = Math.floor((distance % 3600000) / 60000);
        const seconds = Math.floor((distance % 60000) / 1000);

        this.setUnitValues(days, hours, minutes, seconds);
      }

      setUnitValues(days, hours, minutes, seconds) {
        if (this.daysEl) this.daysEl.textContent = this.pad(days);
        if (this.hoursEl) this.hoursEl.textContent = this.pad(hours);
        if (this.minutesEl) this.minutesEl.textContent = this.pad(minutes);
        if (this.secondsEl) this.secondsEl.textContent = this.pad(seconds);
      }

      pad(value) {
        return String(value).padStart(2, '0');
      }

      hideBanner() {
        if (this.hasAttribute('data-design-mode')) return;

        const section = this.closest('.shopify-section');
        if (section) {
          section.hidden = true;
          section.style.display = 'none';
        }
      }

      parseZonedEndDate(dateStr, timeStr, timeZone) {
        if (!dateStr) return NaN;

        const dateMatch = String(dateStr).trim().match(/^(\d{4})-(\d{2})-(\d{2})$/);
        if (!dateMatch) return NaN;

        const timeMatch = String(timeStr || '23:59').trim().match(/^(\d{1,2}):(\d{2})$/);
        if (!timeMatch) return NaN;

        const year = Number(dateMatch[1]);
        const month = Number(dateMatch[2]);
        const day = Number(dateMatch[3]);
        const hour = Number(timeMatch[1]);
        const minute = Number(timeMatch[2]);

        if (
          month < 1 || month > 12 ||
          day < 1 || day > 31 ||
          hour > 23 ||
          minute > 59
        ) {
          return NaN;
        }

        const desiredAsUtc = Date.UTC(year, month - 1, day, hour, minute, 0);
        let utc = desiredAsUtc;

        for (let i = 0; i < 3; i++) {
          const parts = this.getZonedParts(new Date(utc), timeZone);
          if (!parts) return NaN;

          const actualAsUtc = Date.UTC(
            parts.year,
            parts.month - 1,
            parts.day,
            parts.hour,
            parts.minute,
            parts.second
          );
          const diff = desiredAsUtc - actualAsUtc;
          utc += diff;
          if (diff === 0) break;
        }

        return utc;
      }

      getZonedParts(date, timeZone) {
        try {
          const formatter = new Intl.DateTimeFormat('en-US', {
            timeZone: timeZone,
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hourCycle: 'h23'
          });

          const map = {};
          formatter.formatToParts(date).forEach(function (part) {
            if (part.type !== 'literal') map[part.type] = part.value;
          });

          return {
            year: Number(map.year),
            month: Number(map.month),
            day: Number(map.day),
            hour: Number(map.hour),
            minute: Number(map.minute),
            second: Number(map.second)
          };
        } catch (error) {
          return null;
        }
      }
    }
  );
}
